const SkeletonCard = () => {
    return (
        <div className="overflow-hidden bg-[#F9FAFB] shadow sm:rounded-lg rounded-xl w-full max-w-96 p-4 animate-pulse">

            {/* Top Section */}
            <div className="flex justify-between w-full">
                <div className="flex flex-col items-start gap-2">
                    {/* Name */}
                    <div className="h-5 w-32 bg-gray-300 rounded"></div>

                    {/* Label */}
                    <div className="h-3 w-24 bg-gray-200 rounded mt-2"></div>

                    {/* Status */}
                    <div className="h-6 w-40 bg-gray-300 rounded"></div>
                </div>

                {/* Room */}
                <div className="flex flex-col items-start gap-2">
                    <div className="h-3 w-16 bg-gray-200 rounded"></div>
                    <div className="h-5 w-10 bg-gray-300 rounded"></div>
                </div>
            </div>

            {/* Dates */}
            <div className="pt-4 flex justify-between">
                <div className="flex flex-col gap-2">
                    <div className="h-3 w-20 bg-gray-200 rounded"></div>
                    <div className="h-4 w-28 bg-gray-300 rounded"></div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="h-3 w-20 bg-gray-200 rounded"></div>
                    <div className="h-4 w-28 bg-gray-300 rounded"></div>
                </div>
            </div>

            {/* Button */}
            <div className="mt-4">
                <div className="h-10 w-full bg-gray-300 rounded-md"></div>
            </div>
        </div>
    );
};

const GuestListSkeleton = ({ items = 4 }) => {
    return (
        <div className="flex flex-col gap-4 items-center w-full">
            {[...Array(items)].map((_, i) => (
                <SkeletonCard key={i} />
            ))}
        </div>
    );
};

export default GuestListSkeleton;